export default function DeveloperIllustration({ className = "" }) {
  return (
    <div className={`relative ${className}`} aria-hidden="true">
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-accent-cyan/10 via-transparent to-accent-violet/10 blur-2xl" />
      <svg
        viewBox="0 0 400 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative w-full max-w-sm mx-auto drop-shadow-2xl"
      >
        {/* Monitor */}
        <rect x="80" y="120" width="240" height="150" rx="8" fill="#16161f" stroke="#22d3ee" strokeWidth="2" />
        <rect x="90" y="130" width="220" height="120" rx="4" fill="#0a0a0f" />
        {/* Code lines */}
        <rect x="100" y="145" width="80" height="6" rx="2" fill="#22d3ee" opacity="0.9" />
        <rect x="100" y="160" width="120" height="6" rx="2" fill="#a78bfa" opacity="0.7" />
        <rect x="100" y="175" width="60" height="6" rx="2" fill="#22d3ee" opacity="0.5" />
        <rect x="100" y="190" width="140" height="6" rx="2" fill="#a78bfa" opacity="0.6" />
        <rect x="100" y="205" width="90" height="6" rx="2" fill="#22d3ee" opacity="0.4" />
        <rect x="100" y="220" width="110" height="6" rx="2" fill="#a78bfa" opacity="0.5" />
        {/* Cursor blink */}
        <rect x="210" y="220" width="8" height="6" rx="1" fill="#22d3ee">
          <animate attributeName="opacity" values="1;0;1" dur="1.2s" repeatCount="indefinite" />
        </rect>
        {/* Monitor stand */}
        <rect x="185" y="270" width="30" height="20" fill="#2a2a3a" />
        <rect x="160" y="290" width="80" height="8" rx="4" fill="#2a2a3a" />

        {/* Developer head */}
        <circle cx="200" cy="85" r="28" fill="#1e1e2e" stroke="#a78bfa" strokeWidth="2" />
        {/* Glasses */}
        <rect x="178" y="80" width="18" height="12" rx="3" fill="none" stroke="#22d3ee" strokeWidth="2" />
        <rect x="204" y="80" width="18" height="12" rx="3" fill="none" stroke="#22d3ee" strokeWidth="2" />
        <line x1="196" y1="86" x2="204" y2="86" stroke="#22d3ee" strokeWidth="2" />
        {/* Body */}
        <path d="M170 113 Q200 125 230 113 L240 170 Q200 185 160 170 Z" fill="#16161f" stroke="#a78bfa" strokeWidth="1.5" />

        {/* Floating tech icons */}
        <g className="animate-pulse">
          <text x="50" y="100" fill="#22d3ee" fontSize="20" fontFamily="monospace" opacity="0.8">{"{ }"}</text>
          <text x="310" y="90" fill="#a78bfa" fontSize="18" fontFamily="monospace" opacity="0.8">{"</>"}</text>
          <text x="330" y="200" fill="#22d3ee" fontSize="16" fontFamily="monospace" opacity="0.6">{"()"}</text>
          <text x="40" y="220" fill="#a78bfa" fontSize="14" fontFamily="monospace" opacity="0.6">{"[]"}</text>
        </g>

        {/* Terminal window */}
        <rect x="260" y="250" width="110" height="70" rx="6" fill="#0a0a0f" stroke="#a78bfa" strokeWidth="1.5" opacity="0.9" />
        <circle cx="275" cy="263" r="4" fill="#ef4444" opacity="0.8" />
        <circle cx="288" cy="263" r="4" fill="#eab308" opacity="0.8" />
        <circle cx="301" cy="263" r="4" fill="#22c55e" opacity="0.8" />
        <text x="270" y="285" fill="#22d3ee" fontSize="10" fontFamily="monospace">{"> npm run dev"}</text>
        <text x="270" y="300" fill="#a78bfa" fontSize="10" fontFamily="monospace">{"✓ ready"}</text>

        {/* Coffee mug */}
        <rect x="55" y="270" width="30" height="35" rx="4" fill="#16161f" stroke="#22d3ee" strokeWidth="1.5" />
        <path d="M85 280 Q95 280 95 295 Q95 310 85 310" fill="none" stroke="#22d3ee" strokeWidth="1.5" />
        <path d="M60 270 Q70 260 80 270" fill="none" stroke="#a78bfa" strokeWidth="1" opacity="0.5">
          <animate attributeName="opacity" values="0.3;0.7;0.3" dur="2s" repeatCount="indefinite" />
        </path>
      </svg>
    </div>
  );
}
